import Image, { StaticImageData } from 'next/image';
import styles from './hera-page.module.css';
import HeraPageInner from './hera-page-inner';
import HeraPageAbout from './hera-page-about';
import HeraPageFeatures from './hera-page-features';
import {
  Container,
  ContainerFluid,
  IntroSection,
  Notification,
} from '../../components';
import HeraPageIllustrations from './hera-page-illustrations';
import HeraPageAdmin from './hera-page-admin';

import workouts from '../../public/hera/HeraProcess/workouts.png';
import baby from '../../public/hera/HeraProcess/baby.png';
import kitchen from '../../public/hera/HeraProcess/kitchen.png';
import more from '../../public/hera/HeraProcess/more.png';
import banner from '../../public/hera/banner/banner.png';

export interface IIntroSection {
  _id: number;
  title: string;
  text: string;
  img: string | StaticImageData;
  reverse: boolean;
}

const sections: Array<IIntroSection> = [
  {
    _id: 1,
    title: 'BABY DEVELOPMENT',
    text: 'Our team has integrated the 3D baby model so every woman could see lifelike interactive movements and kicks for a realistic representation of what’s happening right inside that growing belly.',
    img: baby,
    reverse: false,
  },
  {
    _id: 2,
    title: 'PERSONALISED WORKOUTS',
    text: 'Fitness video workouts splitted into exercises, reps and rest intervals, yoga full size videos and stretching tips with illustrations - all these represents a FitHub section of the Hera app. Heras workouts are specifically designed to prepare you for baby birth and recovery. Once your baby has arrived, Hera will stay with you throughout your postpartum journey with the special rehabilitation program.',
    img: workouts,
    reverse: true,
  },
  {
    _id: 3,
    title: 'STAGE SPECIFIC NUTRITION PLAN',
    text: "In the Kitchen block of the app you'll find 3 weekly recipes with the meal images, preparation method and grocery list where you can mark the missing ingredients. Hera has created nutrient dense, stage specific meals, snacks and smoothies that will support you and your baby’s development.",
    img: kitchen,
    reverse: false,
  },
  {
    _id: 4,
    title: 'BLOG',
    text: 'Tips, tricks and advice; Hera’s blog will be your best friend. From what to put in your hospital bag to perineal massage to how to encourage your baby’s development. Hera has everything you need at your fingertips.',
    img: more,
    reverse: true,
  },
];

function HeraPage(): JSX.Element {
  return (
    <main className={styles.hera}>
      <HeraPageInner />
      <HeraPageAbout />
      <HeraPageFeatures />
      <Container>
        {sections.map((section) => (
          <IntroSection key={section._id} {...section} />
        ))}
      </Container>
      <HeraPageIllustrations />
      <HeraPageAdmin />
      <ContainerFluid>
        <div className={styles.banner}>
          <Image
            alt="Hera app screens"
            src={banner}
            width={1920}
            height={691}
          />
        </div>
      </ContainerFluid>
      <Container>
        <div className={styles.notification}>
          <Notification
            title="HAVE A PROJECT IN MIND?"
            href="/contact"
            buttonName="Contact us"
          />
        </div>
      </Container>
    </main>
  );
}

export default HeraPage;
